import { motion } from "framer-motion";

const CASES = [
  {
    sector: "Real Assets",
    location: "Providence, RI",
    title: "Providence Waterfront Mixed-Use",
    stats: [{ k: "Capital", v: "$62M" }, { k: "Units", v: "410" }, { k: "Certification", v: "ESG-Aligned" }],
    copy: "410-unit ESG-certified mixed-use development anchoring Providence's next urban chapter — walkable, transit-adjacent, and designed for long-duration yield.",
    image: "https://images.unsplash.com/photo-1764160233831-694591688066?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBjb3Jwb3JhdGUlMjBvZmZpY2UlMjBza3lsaW5lfGVufDB8fHx8MTc4MzI3NTM1Nnww&ixlib=rb-4.1.0&q=85",
  },
  {
    sector: "Technology",
    location: "Rhode Island",
    title: "Northeast AI Data Center Campus",
    stats: [{ k: "Capital", v: "$320M" }, { k: "Power", v: "160MW" }, { k: "Status", v: "Negotiation" }],
    copy: "AI-ready hyperscale campus with on-site combined-cycle backup, interconnected to regional grid and diversified fiber routes.",
    image: "https://images.unsplash.com/photo-1772187693438-12e4b8ef3a29?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxnbG9iYWwlMjBpbmZyYXN0cnVjdHVyZSUyMHNreWxpbmV8ZW58MHx8fHwxNzgzMjc1MzU3fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    sector: "Energy",
    location: "Shandong, China",
    title: "Independent Refinery Crude Program",
    stats: [{ k: "Volume", v: "24M bbl/yr" }, { k: "Tenor", v: "3-Year" }, { k: "Structure", v: "Brent-Linked" }],
    copy: "Multi-year crude supply program to Shandong's independent refining cluster, structured with disciplined hedging and cross-border trade finance.",
    image: "https://images.unsplash.com/photo-1764690341006-965d58fe1dfc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHxnbG9iYWwlMjBpbmZyYXN0cnVjdHVyZSUyMHNreWxpbmV8ZW58MHx8fHwxNzgzMjc1MzU3fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    sector: "Energy",
    location: "Ghana · Côte d'Ivoire · Senegal",
    title: "West African Distributed Solar Portfolio",
    stats: [{ k: "Capacity", v: "220MW" }, { k: "Capital", v: "$95M" }, { k: "Stage", v: "Diligence" }],
    copy: "Distributed solar + storage portfolio across three West African markets, underwritten with PPA-anchored cash flows and sovereign risk mitigants.",
    image: "https://images.unsplash.com/photo-1509391366360-2e959784a276?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwyfHxjbGVhbiUyMGVuZXJneSUyMHNvbGFyJTIwcGFuZWxzfGVufDB8fHx8MTc4MzI3NTM1N3ww&ixlib=rb-4.1.0&q=85",
  },
];

export default function Portfolio() {
  return (
    <div>
      <section className="max-w-[1400px] mx-auto px-6 md:px-10 pt-32 pb-16">
        <div className="eyebrow">Featured Portfolio</div>
        <h1 className="font-display text-5xl md:text-7xl mt-6 leading-[1.02] max-w-4xl">
          Selected mandates, disciplined execution.
        </h1>
        <p className="mt-8 max-w-3xl text-body">
          A representative sample of live and recent transactions across the platform. Additional
          detail available to qualified counterparties through the investor portal.
        </p>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-10 pb-24 space-y-16">
        {CASES.map((c, i) => (
          <motion.article
            key={c.title}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.75 }}
            className={`grid grid-cols-1 lg:grid-cols-12 gap-8 ${i % 2 === 1 ? "lg:flex-row-reverse" : ""}`}
          >
            <div className={`lg:col-span-7 ${i % 2 === 1 ? "lg:order-2" : ""}`}>
              <div className="relative h-[380px] md:h-[460px] overflow-hidden">
                <img src={c.image} alt={c.title} className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#0B1F3A]/70" />
                <div className="absolute bottom-6 left-6 text-[#F8F7F2]">
                  <div className="eyebrow" style={{ color: "#D4AF37" }}>{c.sector}</div>
                  <div className="text-sm mt-1 tracking-widest uppercase">{c.location}</div>
                </div>
              </div>
            </div>
            <div className={`lg:col-span-5 flex flex-col justify-center ${i % 2 === 1 ? "lg:order-1" : ""}`}>
              <h2 className="font-display text-3xl md:text-4xl text-[#0B1F3A] leading-tight">{c.title}</h2>
              <p className="mt-6 text-body">{c.copy}</p>
              <div className="mt-8 grid grid-cols-3 border-t border-[#0B1F3A]/10">
                {c.stats.map(s => (
                  <div key={s.k} className="py-6 border-r last:border-r-0 border-[#0B1F3A]/10">
                    <div className="numeral text-2xl text-[#0B1F3A]">{s.v}</div>
                    <div className="mt-1 text-[10px] uppercase tracking-[0.22em] text-[#5F6B7A]">{s.k}</div>
                  </div>
                ))}
              </div>
            </div>
          </motion.article>
        ))}
      </section>
    </div>
  );
}
